const { DNI_REGEX,  CIF_REGEX} = require('constants/contactCenter/regex');

const validateDNI = function( dni ) {
  const dniReplaced = dni.toUpperCase().replace(/\s/, '');
  let output = false;
  if(dniReplaced.match( DNI_REGEX )){
    const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const letter = dni_letters.charAt( parseInt( dni, 10 ) % 23 );
    output = letter == dni.charAt(8);
  }
  return output;
};

const validateCIF = function( cif ){
  const cfiReplaced = cif.toUpperCase().replace(/\s/, '');
  const match = cfiReplaced.match( CIF_REGEX );
  let output = false;
  if(match){

      const [, letter, number, control] = match;

      let even_sum = 0;
      let odd_sum = 0;
      let n;

      for ( let i = 0; i < number.length; i++) {
        n = parseInt( number[i], 10 );
        if ( i % 2 === 0 ) {
          n *= 2;
          odd_sum += n < 10 ? n : n - 9;
        } else {
          even_sum += n;
        }

      }

      const control_digit = (10 - (even_sum + odd_sum).toString().substr(-1) );
      const control_letter = 'JABCDEFGHI'.substr( control_digit, 1 );

      if ( letter.match( /[ABEH]/ ) ) {
        output = control == control_digit;

      } else if ( letter.match( /[KPQS]/ ) ) {
        output = control == control_letter;

      } else {
        output = control == control_digit || control == control_letter;
      }
  }

  return output;
}

module.exports = {
    validateDNI:validateDNI,
    validateCIF: validateCIF
}
